const AuthTypes = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERROR: 'LOGOUT_ERROR',

  FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR',

  GET_RESET_PASSWORD_REQUEST: 'GET_RESET_PASSWORD_REQUEST',
  GET_RESET_PASSWORD_SUCCESS: 'GET_RESET_PASSWORD_SUCCESS',
  GET_RESET_PASSWORD_ERROR: 'GET_RESET_PASSWORD_ERROR',

  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',

  GET_SET_PASSWORD_REQUEST: 'GET_SET_PASSWORD_REQUEST',
  GET_SET_PASSWORD_SUCCESS: 'GET_SET_PASSWORD_SUCCESS',
  GET_SET_PASSWORD_ERROR: 'GET_SET_PASSWORD_ERROR',

  SET_PASSWORD_REQUEST: 'SET_PASSWORD_REQUEST',
  SET_PASSWORD_SUCCESS: 'SET_PASSWORD_SUCCESS',
  SET_PASSWORD_ERROR: 'SET_PASSWORD_ERROR',

  UPDATE_ACCESS_TOKEN_REQUEST: 'UPDATE_ACCESS_TOKEN_REQUEST',
  UPDATE_ACCESS_TOKEN_SUCCESS: 'UPDATE_ACCESS_TOKEN_SUCCESS',
  UPDATE_ACCESS_TOKEN_ERROR: 'UPDATE_ACCESS_TOKEN_ERROR'
};
export default AuthTypes;
